// extracted by mini-css-extract-plugin
module.exports = {"noData":"SettingsPage_noData__22GZ4","margin":"SettingsPage_margin__3FbNt","SettingsFooter":"SettingsPage_SettingsFooter__36oIr","headerTitle":"SettingsPage_headerTitle__3vO1E"};